module.exports = __webpack_public_path__ + "media/bom/unknown-mounting-type-d31fa0ad.png";